import { Route } from 'react-router-dom'

import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'

import EventSsids from './EventSsids'
import Card from './Card/Card'
import ActionRemove from './Card/ActionRemove'
import EventSsidForm from './Forms/EventSsidForm'

export const EventSsidsRoutes = () => [
  <Route
    path="/event-ssids"
    element={
      <RouteGuard requiredRoles={['cmt']}>
        <EventSsids />
      </RouteGuard>
    }
    key={'event-ssids'}
  >
    <Route path={'new'} element={<EventSsidForm />} />
    <Route path={':id/edit'} element={<EventSsidForm />} />
    <Route path={':id'} element={<Card />}>
      <Route path={'remove'} element={<ActionRemove />} />
    </Route>
  </Route>
]

export default EventSsidsRoutes